const TOKEN_KEY = 'token';

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
  } catch {
    try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; }
  }
}

export function setStoredToken(token) {
  try { localStorage.setItem(TOKEN_KEY, token); } catch { /* noop */ }
  try { sessionStorage.setItem(TOKEN_KEY, token); } catch { /* noop */ }
}

export function clearStoredToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
  try { sessionStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
}